import React from 'react';

import { useIncentivesCreateModalContext } from './IncentivesCreateModalContext';
import TextArea from '../../lib/TextArea';

const IncentivesCreateOffersInfoDescription = () => {
  const { description, setDescription } = useIncentivesCreateModalContext();

  const handleChange = (e: any) => {
    const value = e.target.value;
    setDescription(value);
  };

  return (
    <TextArea
      style={{
        backgroundColor: 'white',
      }}
      value={description}
      placeholder={'Enter incentive description (optional)'}
      rows={3}
      onChange={handleChange}
    />
  );
};

export default IncentivesCreateOffersInfoDescription;
